import { useState } from "react";
import { API } from "@/lib/api";

export default function QuestionImage({ chapterId, level, qi, lang = "en", className, style }) {
  const [failed, setFailed] = useState(false);
  const L = lang === "fr" ? "fr" : "en";
  const src = `${API}/question-image?chapter_id=${encodeURIComponent(chapterId)}&level=${level}&qi=${qi}&lang=${L}`;
  if (failed) return null;
  return (
    <div className="relative" data-testid="question-image-wrap">
      <img key={src} src={src} alt="" loading="lazy" className={className} style={style}
        onError={() => setFailed(true)} data-testid="quiz-image" />
    </div>
  );
}
